import { motion } from "framer-motion";

const EASE = [0.16, 1, 0.3, 1];

export const Footer = ({ onCta }) => {
  return (
    <footer data-testid="site-footer" className="bg-ink text-cream pt-24 md:pt-32 pb-14">
      <div className="mx-auto max-w-[1500px] px-6 md:px-12">
        <motion.h2
          initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }} transition={{ duration: 1, ease: EASE }}
          className="font-display font-black text-5xl md:text-7xl lg:text-8xl leading-[0.98] tracking-tight max-w-6xl mx-auto text-center"
        >
          Your energy is about to be upgraded...
        </motion.h2>

        <div className="mt-14 flex justify-center">
          <button
            data-testid="footer-cta-button"
            onClick={onCta}
            className="group inline-flex items-center bg-rose text-cream text-sm font-semibold uppercase tracking-[0.2em] px-10 py-5 transition-colors duration-300 hover:bg-rose-hover active:scale-[0.98]"
          >
            Send me the meditation
          </button>
        </div>

        <div className="mt-24 flex items-center justify-center border-t border-cream/15 pt-10">
          <span className="text-sm font-light text-cream/60">&copy; {new Date().getFullYear()} j muenz. All rights reserved.</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
